import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between mb-6" }
const _hoisted_2 = { class: "text-primary-500" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M12 4v16m8-8H4"
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Add Photo ")
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = {
  key: 0,
  class: "flex flex-wrap gap-2 mb-6"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 1,
  class: "grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4"
}
const _hoisted_9 = {
  key: 2,
  class: "bg-white rounded-xl border border-primary-200 p-12 text-center"
}
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"w-16 h-16 mx-auto mb-4 bg-primary-100 rounded-full flex items-center justify-center\"><svg class=\"w-8 h-8 text-primary-400\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z\"></path></svg></div><h3 class=\"text-lg font-semibold text-primary-700 mb-2\">No Photos Yet</h3><p class=\"text-primary-500 mb-4\"> Be the first to share a photo from the neighborhood! </p>", 3)
const _hoisted_13 = {
  key: 3,
  class: "grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["src", "alt"]
const _hoisted_16 = { class: "absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-4" }
const _hoisted_17 = {
  key: 0,
  class: "flex flex-wrap gap-1"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-8 h-8",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M6 18L18 6M6 6l12 12"
  })
], -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-10 h-10",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M15 19l-7-7 7-7"
  })
], -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-10 h-10",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M9 5l7 7-7 7"
  })
], -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = { class: "max-w-5xl max-h-[85vh] relative" }
const _hoisted_28 = ["src", "alt"]
const _hoisted_29 = {
  key: 0,
  class: "absolute -bottom-12 left-0 right-0 flex justify-center gap-2"
}
const _hoisted_30 = { class: "w-full max-w-lg bg-white rounded-2xl shadow-xl overflow-hidden" }

import { ref, computed, onMounted } from "vue";
import { HoodApi } from "@/services/HoodApi";
import PhotoUpload from "./PhotoUpload.vue";

interface PhotoTag {
  id: number;
  text: string;
}

interface Photo {
  id: number;
  file: string;
  hash_tag?: PhotoTag[];
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const photos = ref<Photo[]>([]);
const loading = ref(true);
const showUpload = ref(false);
const lightboxPhoto = ref<Photo | null>(null);
const selectedTag = ref<string | null>(null);

// Get all unique tags
const allTags = computed(() => {
  const tags = new Set<string>();
  photos.value.forEach((photo) => {
    photo.hash_tag?.forEach((tag) => tags.add(tag.text));
  });
  return Array.from(tags).sort();
});

// Filter photos by selected tag
const filteredPhotos = computed(() => {
  if (!selectedTag.value) return photos.value;
  return photos.value.filter((photo) =>
    photo.hash_tag?.some((tag) => tag.text === selectedTag.value)
  );
});

// Lightbox navigation
const currentIndex = computed(() => {
  if (!lightboxPhoto.value) return -1;
  return filteredPhotos.value.findIndex(
    (p) => p.id === lightboxPhoto.value?.id
  );
});

const canGoPrev = computed(() => currentIndex.value > 0);
const canGoNext = computed(
  () => currentIndex.value < filteredPhotos.value.length - 1
);

const openLightbox = (photo: Photo) => {
  lightboxPhoto.value = photo;
  document.body.style.overflow = "hidden";
};

const closeLightbox = () => {
  lightboxPhoto.value = null;
  document.body.style.overflow = "";
};

const prevPhoto = () => {
  if (canGoPrev.value) {
    lightboxPhoto.value = filteredPhotos.value[currentIndex.value - 1];
  }
};

const nextPhoto = () => {
  if (canGoNext.value) {
    lightboxPhoto.value = filteredPhotos.value[currentIndex.value + 1];
  }
};

// Keyboard navigation
const handleKeydown = (e: KeyboardEvent) => {
  if (!lightboxPhoto.value) return;
  if (e.key === "Escape") closeLightbox();
  if (e.key === "ArrowLeft") prevPhoto();
  if (e.key === "ArrowRight") nextPhoto();
};

const handleUploadComplete = (newPhoto: Photo) => {
  photos.value.unshift(newPhoto);
  showUpload.value = false;
};

const fetchPhotos = async () => {
  try {
    const response = await HoodApi.fetch_photos();
    if (Array.isArray(response)) {
      photos.value = response;
    }
  } catch (err) {
    console.error("Failed to fetch photos:", err);
  } finally {
    loading.value = false;
  }
};

onMounted(() => {
  fetchPhotos();
  window.addEventListener("keydown", handleKeydown);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(photos.value?.length || 0) + " photos from our community ", 1)
      ]),
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (showUpload.value = true)),
        class: "flex items-center gap-2 px-4 py-2 bg-accent-600 text-white font-medium rounded-lg hover:bg-accent-700 transition-colors shadow-soft"
      }, _hoisted_5)
    ]),
    (_unref(allTags).length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (selectedTag.value = null)),
            class: _normalizeClass(["px-3 py-1.5 text-sm font-medium rounded-full transition-colors", 
          selectedTag.value === null
            ? 'bg-accent-600 text-white'
            : 'bg-white text-primary-600 border border-primary-200 hover:border-primary-300'
        ])
          }, " All Photos ", 2),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(allTags), (tag) => {
            return (_openBlock(), _createElementBlock("button", {
              key: tag,
              onClick: ($event: any) => (selectedTag.value = tag),
              class: _normalizeClass(["px-3 py-1.5 text-sm font-medium rounded-full transition-colors", 
          selectedTag.value === tag
            ? 'bg-accent-600 text-white'
            : 'bg-white text-primary-600 border border-primary-200 hover:border-primary-300'
        ])
            }, " #" + _toDisplayString(tag), 11, _hoisted_7))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(8, (i) => {
            return _createElementVNode("div", {
              key: i,
              class: "aspect-square bg-primary-100 rounded-xl animate-pulse"
            })
          }), 64))
        ]))
      : (!photos.value || photos.value.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (showUpload.value = true)),
              class: "px-4 py-2 bg-accent-600 text-white font-medium rounded-lg hover:bg-accent-700 transition-colors"
            }, " Upload Photo ")
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredPhotos), (photo) => {
              return (_openBlock(), _createElementBlock("div", {
                key: photo.id,
                onClick: ($event: any) => (openLightbox(photo)),
                class: "group relative aspect-square rounded-xl overflow-hidden cursor-pointer bg-primary-100 shadow-soft hover:shadow-card transition-all duration-300"
              }, [
                _createElementVNode("img", {
                  src: photo.file,
                  alt: photo.hash_tag?.[0]?.text || 'Community photo',
                  class: "w-full h-full object-cover transition-transform duration-300 group-hover:scale-105",
                  loading: "lazy"
                }, null, 8, _hoisted_15),
                _createElementVNode("div", _hoisted_16, [
                  (photo.hash_tag && photo.hash_tag.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(photo.hash_tag.slice(0, 3), (tag) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: tag.id,
                            class: "px-2 py-0.5 text-xs font-medium bg-white/20 text-white rounded-full backdrop-blur-sm"
                          }, " #" + _toDisplayString(tag.text), 1))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ], 8, _hoisted_14))
            }), 128))
          ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, {
        "enter-active-class": "transition ease-out duration-200",
        "enter-from-class": "opacity-0",
        "enter-to-class": "opacity-100",
        "leave-active-class": "transition ease-in duration-150",
        "leave-from-class": "opacity-100",
        "leave-to-class": "opacity-0"
      }, {
        default: _withCtx(() => [
          (lightboxPhoto.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "fixed inset-0 z-50 flex items-center justify-center bg-black/90 p-4",
                onClick: _withModifiers(closeLightbox, ["self"])
              }, [
                _createElementVNode("button", {
                  onClick: closeLightbox,
                  class: "absolute top-4 right-4 p-2 text-white/70 hover:text-white transition-colors"
                }, _hoisted_20),
                (_unref(canGoPrev))
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: _withModifiers(prevPhoto, ["stop"]),
                      class: "absolute left-4 p-2 text-white/70 hover:text-white transition-colors"
                    }, _hoisted_23, 8, _hoisted_21))
                  : _createCommentVNode("", true),
                (_unref(canGoNext))
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      onClick: _withModifiers(nextPhoto, ["stop"]),
                      class: "absolute right-4 p-2 text-white/70 hover:text-white transition-colors"
                    }, _hoisted_26, 8, _hoisted_24))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("img", {
                    src: lightboxPhoto.value.file,
                    alt: lightboxPhoto.value.hash_tag?.[0]?.text || 'Community photo',
                    class: "max-w-full max-h-[85vh] object-contain rounded-lg"
                  }, null, 8, _hoisted_28),
                  (lightboxPhoto.value.hash_tag && lightboxPhoto.value.hash_tag.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lightboxPhoto.value.hash_tag, (tag) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: tag.id,
                            class: "px-3 py-1 text-sm font-medium bg-white/10 text-white rounded-full backdrop-blur-sm"
                          }, " #" + _toDisplayString(tag.text), 1))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ], 8, _hoisted_18))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, {
        "enter-active-class": "transition ease-out duration-200",
        "enter-from-class": "opacity-0",
        "enter-to-class": "opacity-100",
        "leave-active-class": "transition ease-in duration-150",
        "leave-from-class": "opacity-100",
        "leave-to-class": "opacity-0"
      }, {
        default: _withCtx(() => [
          (showUpload.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4",
                onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (showUpload.value = false), ["self"]))
              }, [
                _createElementVNode("div", _hoisted_30, [
                  _createVNode(PhotoUpload, {
                    onUpload_complete: handleUploadComplete,
                    onClose: _cache[3] || (_cache[3] = ($event: any) => (showUpload.value = false))
                  })
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]))
  ]))
}
}

})